// utils
import persistedState from '@hjgy/common/persistedState';

import { namespace, actions as $actions, mutations as $mutations } from './types';
import BrandBusinessSetting from '@hjgy/common/constant/BrandBusinessSetting';
import { getSettingsByCode } from '@/apis/brandBusinessSettingApi';
import loadBMap from '@/utils/loadBMap';

const DEFAULT_AK = 'Gms5PQRmS1kTaUPGT61iIOXh8AATg3Ed';

/**
 * state
 */
const state = persistedState(
  namespace,
  {},
  {
    ak: undefined,
  },
);

/**
 * getters
 */
const getters = {};

/**
 * actions
 */
const actions = {
  [$actions.loadAk]: async ({ commit, state }) => {
    if (state.ak) {
      return state.ak;
    }

    const { brandBusinessSetting } = await getSettingsByCode({ code: BrandBusinessSetting.BaiDuMapAK.value });
    const ak = brandBusinessSetting?.value || DEFAULT_AK;
    commit($mutations.setAk, { ak });
    return ak;
  },
  [$actions.loadBMap]: async ({ dispatch }) => {
    const ak = await dispatch($actions.loadAk);
    return loadBMap(ak);
  },
};

/**
 * mutations
 */
const mutations = {
  [$mutations.setAk](state, { ak }) {
    state.ak = ak;
  },
};

export default {
  namespaced: true,

  state,

  getters,

  actions,

  mutations,
};
